import StationFeatureIcon from "../station-feature-icon/station-feature-icon";
import styles from "./station-feature-list.module.less";

type TStationFeatureListProps = {
  items: Array<TStationFeature>;
};

export type TStationFeature = {
  id: string;
  text: string;
};

const StationFeatureList = ({ items }: TStationFeatureListProps) => {
  return (
    <ul className={styles.list}>
      {items.map((item, index) => {
        return (
          <li key={index} className={styles.item}>
            <span className={styles.icon}>
              <StationFeatureIcon feature={item} />
            </span>
            <span className={styles.text}>{item.text}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default StationFeatureList;
